import { cn } from "@/lib/utils"
import { useSidebar } from "./sidebar-context"
import { Link } from "react-router-dom"

export function SidebarNav({ 
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLElement>) {
  return (
    <nav
      className={cn("flex flex-col gap-1", className)}
      {...props}
    >
      {children}
    </nav>
  )
}

export function SidebarNavLink({ 
  icon: Icon,
  children,
  to,
  active,
  className,
  onClick,
  ...props
}: {
  icon: React.ElementType
  children: React.ReactNode
  to: string
  active?: boolean
  className?: string
  onClick?: (e: React.MouseEvent) => void
}) {
  const { isCollapsed } = useSidebar()

  return (
    <Link
      to={to}
      onClick={onClick}
      className={cn(
        "group flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors",
        active
          ? "bg-primary-50 text-primary-600"
          : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
        className
      )}
      {...props}
    >
      <Icon
        className={cn(
          "h-5 w-5 shrink-0",
          active
            ? "text-primary-600"
            : "text-gray-400 group-hover:text-gray-500"
        )}
      />
      <span className={cn(
        "transition-opacity",
        isCollapsed ? "opacity-0 group-hover:opacity-100" : "opacity-100"
      )}>
        {children}
      </span>
    </Link>
  )
}